const filterSubMarket = () => {
    $("#country-filter #market").on("change", function(e) {
        var market = $(this).val();
        $.post({
            url: `/api/submarkets?market=${market}`,
            success: function(response) {
                $("#country-filter #submarket").empty();

                $("#country-filter #submarket").append(
                    "<option disabled selected value='select'> Selecciona una región </option>"
                );
                for (const key in response) {
                    $("#country-filter #submarket").append(
                        "<option value='" + key + "'>" + key + "</option>"
                    );
                    // localStorage.setItem("marker", market);
                }
            },
            error: function() {
                console.log("Ocurrio un error");
            }
        });
    });




    $("#main-properties-filter #market").on("change", function() {
        var market = $(this).val();

        $.post({
            url: ` /api/submarkets?market=${market}`,
            success: function(response) {
                $("#main-properties-filter #submarket").empty();
                $("#main-properties-filter #submarket").append(
                    "<option disabled selected value='select'> Selecciona una región </option>"
                );
                for (const key in response) {
                    $("#main-properties-filter #submarket").append(
                        "<option value='" + key + "'>" + key + "</option>"
                    );
                }
                // localStorage.setItem("marker", market);
            },
            error: function() {
                console.log("Ocurrio un error");
            }
        });
    });

    $("#results-filter #market").on("change", function() {
        var market = $(this).val();

        $.post({
            url: ` /api/submarkets?market=${market}`,
            success: function(response) {
                $("#results-filter  #submarket").empty();
                $("#results-filter #submarket").append(
                    "<option disabled selected value='select'> Selecciona una región </option>"
                );
                for (const key in response) {
                    $("#results-filter  #submarket").append(
                        "<option value='" + key + "'>" + key + "</option>"
                    );
                }
                // localStorage.setItem('marker', market)

            },
            error: function() {
                console.log("Ocurrio un error");
            }
        });
    });
    $(document).ready(function (){
        const storage = $("#results-filter #market").val()
        if (!storage) return

        $.post({
            url: `/api/submarkets?market=${storage}`,
            success: function(response) {
                $("#results-filter #submarket").empty();

                $("#results-filter #submarket").append(
                    "<option disabled selected value='select'> Selecciona una región </option>"
                );
                for (const key in response) {
                    $("#results-filter #submarket").append(
                        "<option value='" + key + "'>" + key + "</option>"
                    );
                }
            },
            error: function() {
                console.log("Ocurrio un error");
            }
        });
    })
};

export default filterSubMarket;
